<template>
    <!-- Page header -->
    <div>
        <div class="page-header page-header-light">
            <div class="page-header-content header-elements-md-inline">
                <div class="page-title d-flex">
                    <h4><span class="font-weight-semibold">Event summary</span></h4>
                    Click on particular column number to drill down into seeing what kind of events has been received for
                    particular event type
                </div>
            </div>
        </div>
        <!-- /page header -->
        <!-- Content area -->
        <div class="content">
            <div class="card">
                <div class="table-responsive" :class="{ 'loading-mask': loading }">
                    <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">Refresh list</button>
                    <div style="float:left; margin-top: 10px">
                        <datetime type="date" :input-class="'form-control'" :placeholder="'Choose `from` date'"
                            style="margin-left: 20px; float: left; width: 200px" v-model="from"></datetime>
                        <datetime type="date" :input-class="'form-control'" :placeholder="'Choose `to` date'"
                            style="margin-left: 20px; float: left; width: 200px" v-model="to"></datetime>

                        Show domain with at least number of events:
                        <input placeholder="Filter by number of events"
                            style="border: 1px solid grey; margin-top: 10px; margin: 10px" type="number" min="1" class=""
                            v-model="limit" />
                        <button @click="load" class="btn btn-primary pull-right" style="margin: 10px">
                            Load
                        </button>
                    </div>
                    <table class="table table-striped table-xs" style="min-height: 100px">
                        <thead>
                            <tr>
                                <th>No.</th>
                                <th>Domain</th>
                                <th>Sent</th>
                                <th>Delivered</th>
                                <th v-tooltip="'Open / Sent'">Open</th>
                                <th v-tooltip="'Click / Sent % | Click / Open %'">Click</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="r, k in rows">
                                <td style="width:10px">{{ k + 1 }}</td>
                                <td>{{ r._id.domain }}</td>
                                <td>{{ r.count_processed || 0 }}</td>
                                <td>{{ r.count_delivered || 0 }}</td>
                                <td>{{ r.count_open || 0 }} ({{ (((r.count_open || 0) / (r.count_processed || 0))
                                    *
                                    100).toFixed(2) }}%)
                                </td>
                                <td>{{ r.count_click || 0 }} ({{ (((r.count_click || 0) / (r.count_processed ||
                                    0)) *
                                    100).toFixed(2) }}% {{ (((r.count_click || 0) / (r.count_open || 0)) *
        100).toFixed(2) }}%)</td>
                                <td>
                                </td>
                            </tr>
                            <h2 v-if="rows.length === 0"> </h2>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
let queryDebounce
import moment from 'moment'
import EventBus from '@/event_bus'
export default {
    data() {
        return {
            showUpload: false,

            from: moment().add('day', -7).toISOString(),
            to: moment().toISOString(),

            rows: [],
            loading: true,
            adding: false,
            limit: 25,
            offset: 0,
            count: 0,
            query: null,
            limit: 1000
        }
    },
    watch: {
        from() {
            this.load()
        }
    },
    computed: {
        pages() {
            if (this.count <= this.limit) {
                return 1
            }

            return Math.ceil(this.count / this.limit)
        },
        page() {
            if (this.offset === 0) {
                return 1
            }
            return (this.offset / this.limit) + 1 || 1
        },
    },
    methods: {
        modifyDay(d) {
            this.from = moment(this.from).add(d, 'day').toISOString()
        },
        prevPage() {
            this.offset -= 25
            this.load()
        },
        nextPage() {
            this.offset += 25
            this.load()

        },
        load() {
            this.loading = true
            this.$api.getReq(`event_summary/receiving/` + moment(this.from).toDate().getTime() + "/" + moment(this.to).toDate().getTime(), { limit: this.limit }).then(res => {
                this.rows = res.body.data
                this.count = res.body.data.length
                this.loading = false
            })
        }
    },
    destroyed() { },
    mounted() {
        this.load()
    }
}
</script>
<style>
.avsquare {
    width: 7px;
    height: 100%;
    float: left;
    cursor: pointer;
    border-left: 1px solid rgba(0, 0, 0, .1);
}

.avsquare:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.avsquare:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

tbody .btn {
    padding: 3px 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/EventSummaryReceiving.vue